export default __webpack_public_path__ + "static/media/plant1.7c3874fb.png";